
import { useProject } from '@/Hooks/UseProject'
import useTranslation from '@/Hooks/UseTranslation'
import InterfaceActions from '@/Redux/Actions/InterfaceActions'
import ProjectCNCActions from '@/Redux/Actions/ProjectCNCActions'
import React from 'react'
import { Card } from 'react-bootstrap'
import { useDispatch } from 'react-redux'

import './CncTypesList.scss'

interface Props {
  list: any[]
  onUpdateList: () => Promise<void>
}

const CncTypesList = (props: Props) => {

  const { list, onUpdateList } = props

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { project } = useProject()

  const updateRow = async (row: any, e: any) => {

    const data = {
      enabled: e.target.checked
    }

    dispatch(InterfaceActions.showLoader())

    await dispatch(ProjectCNCActions.updateRow(project._id, row._id, data))

    await onUpdateList()

    dispatch(InterfaceActions.hideLoader())
  }

  return (
    <Card className="table-card cnc-list">
      <div>
        <div className="table-responsive">
          <table className="table card-table">
            <thead>
              <th>
                {t('RESOURCES_CNC:SettingsCodeColumn')}
              </th>
              <th>
                {t('RESOURCES_CNC:SettingsDescriptionColumn')}
              </th>
              <th>
                {t('RESOURCES_CNC:SettingsTypeColumn')}
              </th>
              <th style={{ width: 100}}>
                {t('RESOURCES_CNC:SettingsStatusColumn')}
              </th>
            </thead>
            <tbody>
              {list.map((projectCnc: any, i: number) => (
                <tr key={`${i}-${projectCnc._id}`}>
                  <td>{projectCnc.cnc.code}</td>
                  <td>{projectCnc.cnc.name}</td>
                  <td>
                    {projectCnc.cnc.type === "obra_construccion" && t('RESOURCES_CNC:ProjectConstructionCNCType')}
                    {projectCnc.cnc.type === "diseno_oficina_tecnica_de_obra" && t('RESOURCES_CNC:DesignOTOCNCType')}
                    {projectCnc.cnc.type === "administracion" && t('RESOURCES_CNC:AdministrationCNCType')}
                    {projectCnc.cnc.type === "logistica" && t('RESOURCES_CNC:LogisticsCNCType')}
                    {projectCnc.cnc.type === "condiciones_externas" && t('RESOURCES_CNC:ExternalConditionsCNCType')}
                  </td>
                  <td>
                    <label className="switch pr-5 switch-primary mr-3" style={{ paddingLeft: 0 }}>
                      {/* <span>
                        {projectCnc.enabled ? t('RESOURCES_CNC:SettingsStatusActive') : t('RESOURCES_CNC:SettingsStatusInactive')}
                      </span> */}
                      <input
                        type="checkbox"
                        checked={projectCnc.enabled}
                        onChange={(e: any) => updateRow(projectCnc, e)}
                      />
                      <span className="slider"></span>
                    </label>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Card>
  )
}

export default CncTypesList
